import { useNavigate } from "react-router-dom";
import { UserRound, Building2 } from "lucide-react";
import { useLang } from "@/lib/i18n";

export const AccountTypeSwitch = ({ active }) => {
  const { t } = useLang();
  const navigate = useNavigate();

  return (
    <div className="grid grid-cols-2 gap-1 p-1 border border-border rounded-full bg-muted/50 mb-6" data-testid="account-type-switch">
      <button
        type="button"
        data-testid="account-type-user"
        onClick={() => active !== "user" && navigate("/register")}
        className={`flex items-center justify-center gap-2 rounded-full py-2 text-sm font-medium transition-colors ${active === "user" ? "bg-accent text-accent-foreground" : "text-muted-foreground hover:text-foreground"}`}
      >
        <UserRound className="h-4 w-4" /> {t("account_user")}
      </button>
      <button
        type="button"
        data-testid="account-type-assoc"
        onClick={() => active !== "assoc" && navigate("/register-association")}
        className={`flex items-center justify-center gap-2 rounded-full py-2 text-sm font-medium transition-colors ${active === "assoc" ? "bg-accent text-accent-foreground" : "text-muted-foreground hover:text-foreground"}`}
      >
        <Building2 className="h-4 w-4" /> {t("account_assoc")}
      </button>
    </div>
  );
};
